export default {
  VIDEOS: "videos",
  ACTIVITIES: "activities",
  TAGS: "tags",
  PROFILES: "profiles",
  ACCOUNT_SETTINGS: "account-settings",
  LOGIN: "login",
};
